export default __webpack_public_path__ + "static/media/Conduction2Img4.58ff3e76.png";